import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { GlobalVariables } from 'app/services/globals';
import { ColumnPhysicalType, ColumnType } from 'app/shared/utils/column-type.util';
import { uniq } from 'lodash';

export const dataflowSupportedIcebergLSTypes = [
    adfModelTypeMap.azureBlob.linkedServiceType,
    adfModelTypeMap.amazonS3.linkedServiceType,
    adfModelTypeMap.azureBlobFS.linkedServiceType
];

export const copySupportedIcebergLSTypes = [adfModelTypeMap.azureBlobFS.linkedServiceType];

const getSupportedLinkedServiceTypes = () => {
    const result = [...copySupportedIcebergLSTypes];
    if (GlobalVariables.enableIcebergFormat) {
        result.push(...dataflowSupportedIcebergLSTypes);
    }
    return uniq(result);
}

export const icebergMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.iceberg.datasetType,
    displayName: stringResources.Iceberg_DisplayText,
    supportLinkedServiceTypes: getSupportedLinkedServiceTypes(),
    supportDeleteActivity: false,
    icon: {
        className: 'svg-i-20x20-Iceberg'
    },
    isSource: false,
    isSink: true,
    supportEditPhysicalType: true,
    isFirstClass: true,
    category: ['File'],
    isV2FormatDataset: true,
    datasetKind: 'file',
    supportDataFlowSink: GlobalVariables.enableIcebergFormat,
    supportDataFlowSource: GlobalVariables.enableIcebergFormat,
    supportGetMetadataActivity: false,
    supportDataTypes: [
        ColumnType.Boolean,
        ColumnType.Int32,
        ColumnType.Int64,
        ColumnType.Single,
        ColumnType.Double,
        ColumnType.Decimal,
        ColumnType.Date,
        ColumnType.TimeSpan,
        ColumnType.DateTime,
        ColumnType.DateTimeOffset,
        ColumnType.String
    ],
    LogicalToPhysicalMapping: {
        boolean: ColumnPhysicalType.Boolean,
        int32: ColumnPhysicalType.Int,
        int64: ColumnPhysicalType.Long,
        single: ColumnPhysicalType.Float,
        double: ColumnPhysicalType.Double,
        decimal: ColumnPhysicalType.Decimal,
        date: ColumnPhysicalType.Date,
        timespan: ColumnPhysicalType.Time,
        datetime: ColumnPhysicalType.Timestamp,
        datetimeoffset: ColumnPhysicalType.TimestampTimeZone,
        string: ColumnPhysicalType.String
    },
    PhysicalToLogicalMapping: {
        boolean: ColumnType.Boolean,
        int: ColumnType.Int32,
        long: ColumnType.Int64,
        float: ColumnType.Single,
        double: ColumnType.Double,
        decimal: ColumnType.Decimal,
        date: ColumnType.Date,
        time: ColumnType.TimeSpan,
        timestamp: ColumnType.DateTime,
        timestamptz: ColumnType.DateTimeOffset,
        string: ColumnType.String
    },
    supportedPhysicalTypes: [
        ColumnPhysicalType.Boolean,
        ColumnPhysicalType.Int,
        ColumnPhysicalType.Long,
        ColumnPhysicalType.Float,
        ColumnPhysicalType.Double,
        ColumnPhysicalType.Decimal,
        ColumnPhysicalType.Date,
        ColumnPhysicalType.Time,
        ColumnPhysicalType.Timestamp,
        ColumnPhysicalType.TimestampTimeZone,
        ColumnPhysicalType.String
    ],
    precisionMap: {
        decimal: {
            minValue: 1,
            maxValue: 38,
            defaultValue: 18
        }
    },
    scaleMap: {
        decimal: {
            minValue: 0,
            maxValue: 38,
            defaultValue: 18
        }
    }
};
